import React, { useEffect } from "react";
import { connect } from "react-redux";
import SOpaymentTermsComponent from "./SOpaymentTermsComponent";
import { BrandsManagementsFunction } from "../../redux/index";
import { useParams } from "react-router";
import { EndPoints } from "../../utils/EndPoints";

function SOpaymentTermsContainer(props) {
  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = () => {
    if (props.user.uid) {
      props.BrandsManagementsFunction("get", EndPoints["SOpaymentTerms"]);
    }
  };

  const { tab, id } = useParams();
  const params = { tab: tab, id: id };
  return <SOpaymentTermsComponent {...props} params={params} />;
}

const mapStateToProps = (state) => ({
  user: state.authentication.user,
  SOpaymentTerms: state.modules.SOpaymentTerms,
  [EndPoints["SOpaymentTerms"]]: state.modules[EndPoints["SOpaymentTerms"]],
  loading: state.modules.loading,
});
const mapDispatchToProps = {
  BrandsManagementsFunction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SOpaymentTermsContainer);
